export default "__VITE_ASSET__ed63b461__"